import React, { useEffect, useState } from "react";
import AdminHeading from "../AdminPanel/Heading/AdminHeading";
import AdminBreadCrump from "../AdminPanel/Heading/AdminBreadCrump";
import "../PagesStyles/AdminMasters.css";
import { TbCircleNumber1 } from "react-icons/tb";
import { Icon } from "@iconify/react";
import { useRef } from "react";

import {
  a100,
  a104,
  a107,
  a108,
  a109,
  a110,
  a111,
  a112,
  a119,
  a120,
  a121,
  a122,
  a123,
  a124,
  a125,
  a126,
  a127,
  a128,
  a129,
  a130,
  a131,
  a132,
  a133,
  a149,
  a150,
  a151,
  a18,
  a35,
  a7,
  a95,
  a96,
  a97,
  a98,
  a99,
  a207,
  a210,
  a213,
} from "../../Api/RootApiPath";
import { useSelector } from "react-redux";
import { RiListUnordered, RiPlayListAddLine } from "react-icons/ri";
import AlertMessage from "../../Other Functions/AlertMessage";
import { allCountriesList } from "../../Api/CountriesAllList";
import { allStateList } from "../../Api/StateList";
import Customertable from "Components/support/customervendor/customer";
import { Box } from "@mui/material";
import style from "./AddNewCustomer.module.css";
import style2 from "../../../Components/support/customervendor/Customer.module.css";

export default function AddVendorNew() {
  const [active, setActive] = useState("AddNew");
  const [showError, setShowError] = useState(false);
  const [messageType, setMessageType] = useState("");
  const [messageToShow, setMessageToShow] = useState("");
  const [loading, setLoading] = useState(false);
  const [allCategories, setAllCategories] = useState([]);
  const [newCategory, setNewCategory] = useState({
    VendorCode: "",
    VendorName: "",
    VendorPanNo: "",
    ContactNo: "",
    Email: "",
    Address: "",
    State: "",
    Area: "",
    City: "",
    Country: "India",
    FirmName: "",
    FirmDetails: "",
    GSTNo: "",
    CGSTNo: "",
    VendorType: "",
    OnlineStatus: "Active",
    BalanceAmt: "0",
    FineSilver: "0",
    FineGold: "0",
    InwardNo: "0",
    AdvanceAmt: "0",
    InwardGold: "0",
    InwardSilver: "0",
    CustomerId: 0,
    AddToCustomer: false,
    OldEntry: false,
  });
  const [allCompaniesList, setAllCompaniesList] = useState([]);
  const [allBranchesList, setAllBranchesList] = useState([]);
  const [allDepartmentsList, setAllDepartmentsList] = useState([]);
  const [countryStates, setCountryStates] = useState([]);
  const [allRolesList, setAllRolesList] = useState([]);
  const [allCategoriesList, setAllCategoriesList] = useState([]);
  const [allProductsList, setAllProductsList] = useState([]);
  const [customerSlabList, setCustomerSlabList] = useState([]);
  const [customerRateOfInterestList, setCustomerRateOfInterestList] = useState(
    []
  );
  const [customerCreditPeriodList, setCustomerCreditPeriodList] = useState([]);

  const inputRef1 = useRef(null);
  const inputRef2 = useRef(null);
  const inputRef3 = useRef(null);
  const inputRef4 = useRef(null);
  const inputRef5 = useRef(null);
  const inputRef6 = useRef(null);
  const inputRef7 = useRef(null);
  const inputRef8 = useRef(null);
  const inputRef9 = useRef(null);
  const inputRef10 = useRef(null);
  const inputRef11 = useRef(null);
  const inputRef12 = useRef(null);
  const inputRef13 = useRef(null);
  const inputRef14 = useRef(null);
  const inputRef15 = useRef(null);
  const inputRef16 = useRef(null);
  const inputRef17 = useRef(null);
  const inputRef18 = useRef(null);
  const inputRef19 = useRef(null);
  const inputRef20 = useRef(null);
  const inputRef21 = useRef(null);
  const inputRef22 = useRef(null);
  const inputRef23 = useRef(null);

  // Focus inputRef1 on component mount
  useEffect(() => {
    inputRef1.current?.focus();
  }, []);
  // Handler function to move focus on Enter key press

  const handleResetField = () => {
    // List of all input and select refs
    const allRefs = [
      inputRef1,
      inputRef2,
      inputRef3,
      inputRef4,
      inputRef5,
      inputRef6,
      inputRef7,
      inputRef8,
      inputRef9,
      inputRef10,
      inputRef11,
      inputRef12,
      inputRef13,
      inputRef14,
      inputRef15,
      inputRef16,
      inputRef17,
      inputRef18,
      inputRef19,
      inputRef20,
      inputRef21,
      inputRef22,
    ];

    // Loop through each ref and reset the value
    allRefs.forEach((ref) => {
      if (ref.current) {
        if (ref.current.tagName === "SELECT") {
          ref.current.selectedIndex = 0; // Reset <select> to the first option
        } else {
          ref.current.value = ""; // Clear input field
        }
      }
    });

    // Refocus on the first input after reset
    inputRef1.current?.focus();
  };

  const handleKeyPress = (e, nextInputRef) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default form submission on Enter
      if (nextInputRef) {
        nextInputRef.current?.focus();
      } else {
        if (submitButtonRef.current) {
          submitButtonRef.current.click(); // Safely trigger click
        } else {
          console.error("Submit button ref is not available");
        }
      }
    }
  };

  const [searchInput, setSearchInput] = useState("");

  const handleSearchChange = (event) => {
    setSearchInput(event.target.value);
  };

  const allStates = useSelector((state) => state);
  const adminLoggedIn = allStates.reducer1;
  //   let Entryby_Staff_id = parseInt(adminLoggedIn);
  const clientCode = adminLoggedIn.ClientCode;
  const employeeCode = adminLoggedIn.EmployeeCode;
  const states = {
    US: ["California", "Texas", "Florida", "New York"],
    IN: allStateList,
  };
  useEffect(() => {
    window.scroll(0, 0);
  }, []);
  const fetchAllCategory = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a149, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCategories(data);
      } else {
        setActive("addNew");
        document
          .getElementById("addCategoryListTitle")
          .classList.add("activeCategoryTitle");
        document
          .getElementById("addCategoryListLogo")
          .classList.add("activeCategoryLogo");
        document.getElementById("addCategoryListTitle").click();
      }
    } catch (error) {
      console.log(error);
    }
  };
  const fetchAllCustomersSlab = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a207, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setCustomerSlabList(data);
      } else {
        alert("Please Add Customers Slab First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersSlab();
  }, []);

  const fetchAllCustomersRateOfInterest = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a210, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setCustomerRateOfInterestList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersRateOfInterest();
  }, []);

  const fetchAllCustomersCreditPeriod = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a213, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    console.log(data, "data,");
    try {
      if (data.length > 0) {
        setCustomerCreditPeriodList(data);
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllCustomersCreditPeriod();
  }, []);

  useEffect(() => {
    fetchAllCategory();
  }, []);
  const fetchAllCompanies = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a95, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCompaniesList(data);
      } else {
        // alert("Please Add Company First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCompanies();
  }, []);
  const fetchAllBranches = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a98, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllBranchesList(data);
      } else {
        // alert("Please Add Branch First");
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAllBranches();
  }, []);

  const fetchAllDepartments = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a104, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllDepartmentsList(data);
      } else {
        // alert("Please Add Department First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllDepartments();
  }, []);
  const fetchAllRoles = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a107, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllRolesList(data);
      } else {
        // alert("Please Add Role First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllRoles();
  }, []);
  const fetchAllCategoriesList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a125, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllCategoriesList(data);
      } else {
        // alert("Please Add Category First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllCategoriesList();
  }, []);
  const fetchAllProductsList = async () => {
    const formData = {
      ClientCode: clientCode,
    };
    const response = await fetch(a128, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });
    const data = await response.json();
    try {
      if (data.length > 0) {
        setAllProductsList(data);
      } else {
        // alert("Please Add Product First");
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchAllProductsList();
    if (newCategory.Country == "India") {
      setCountryStates(states.IN);
    }
  }, []);
  const handleNewCategoryChange = (e) => {
    const { name, value } = e.target;

    if (name == "Country" && value == "India") {
      setCountryStates(states.IN);
      setNewCategory({ ...newCategory, Country: value, State: "" });
    } else if (name == "Country" && value == "United States") {
      setCountryStates(states.US);
      setNewCategory({ ...newCategory, Country: value, State: "" });
    } else {
      setNewCategory({ ...newCategory, [name]: value });
      setCountryStates([]);
    }
    if (name == "AddToCustomer") {
      if (!newCategory.OldEntry) {
        setNewCategory({
          ...newCategory,
          [name]:
            name === "VendorCode"
              ? !newCategory.OldEntry
                ? allCategories.length + 1
                : newCategory.VendorCode
              : value,
        });
      } else {
        setMessageType("error");
        setMessageToShow("Kindly Change it from Settings");
        setShowError(true);
      }
    } else {
      setNewCategory({
        ...newCategory,
        [name]:
          name === "VendorCode"
            ? !newCategory.OldEntry
              ? allCategories.length + 1
              : newCategory.VendorCode
            : value,
      });
    }
  };

  const addNewCategory = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formData = {
      ClientCode: clientCode,
      VendorCode: !newCategory.OldEntry
        ? String(allCategories.length + 1)
        : String(newCategory.VendorCode),
      VendorName: newCategory.VendorName,
      VendorPanNo: newCategory.VendorPanNo,
      ContactNo: newCategory.ContactNo,
      Email: newCategory.Email,
      Address: newCategory.Address,
      State: newCategory.State,
      Area: newCategory.Area,
      City: newCategory.City,
      Country: newCategory.Country,
      FirmName: newCategory.FirmName,
      FirmDetails: newCategory.FirmDetails,
      GSTNo: newCategory.GSTNo,
      CGSTNo: newCategory.CGSTNo,
      VendorType: newCategory.VendorType,
      OnlineStatus: newCategory.OnlineStatus,
      BalanceAmt: newCategory.BalanceAmt,
      FineSilver: newCategory.FineSilver,
      FineGold: newCategory.FineGold,
      InwardNo: newCategory.InwardNo,
      AdvanceAmt: newCategory.AdvanceAmt,
      InwardGold: newCategory.InwardGold,
      InwardSilver: newCategory.InwardSilver,
      CustomerId: newCategory.CustomerId,
      AddToCustomer: newCategory.AddToCustomer === "true",

      ...(newCategory.OldEntry ? { Id: newCategory.Id } : {}),
    };
    try {
      const response = await fetch(
        !newCategory.OldEntry ? a151 : a150,
        // a96,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      fetchAllCategory();
      setActive("List");
      setNewCategory({
        VendorCode: !newCategory.OldEntry
          ? allCategories.length + 1
          : newCategory.VendorCode,
        VendorName: "",
        VendorPanNo: "",
        ContactNo: "",
        Email: "",
        Address: "",
        State: "",
        Area: "",
        City: "",
        Country: "India",
        FirmName: "",
        FirmDetails: "",
        GSTNo: "",
        CGSTNo: "",
        VendorType: "",
        OnlineStatus: "Active",
        BalanceAmt: "0",
        FineSilver: "0",
        FineGold: "0",
        InwardNo: "0",
        AdvanceAmt: "0",
        InwardGold: "0",
        InwardSilver: "0",
        CustomerId: 0,
        AddToCustomer: false,
        OldEntry: false,
      });
      if (data.message) {
        // alert(data.message);
        setMessageType("error");
        setMessageToShow(data.message);
        setShowError(true);
        setActive("AddNew");
      } else {
        setMessageType("success");
        setMessageToShow("Category Added Successfully");
        setShowError(true);
      }
      setLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    setTimeout(() => {
      setShowError(false);
    }, 2000);
  }, [showError]);

  const handleEditData = (data) => {
    setNewCategory({ ...data, OldEntry: true });
    setActive("AddNew");
  };

  // const handleReset = () => {
  //   setNewCs({
  //     FirstName: "",
  //     LastName: "",
  //     MiddleName: "",
  //     PerAddStreet: "",
  //     CurrAddStreet: "",
  //     Mobile: "",
  //     Email: "",
  //     Password: "",
  //     CustomerLoginId: "",
  //     DateOfBirth: "",
  //     PerAddPincode: "",
  //     Gender: "",
  //     CustomerSlabId: 0,
  //     CreditPeriodId: 0,
  //     RateOfInterestId: 0,
  //     OnlineStatus: "",
  //     CurrAddTown: "",
  //     CurrAddPincode: "",
  //     CurrAddState: "",
  //     PerAddTown: "",
  //     PerAddState: "",
  //     CurrAddCountry: "India",
  //     PerAddCountry: "India",
  //     GstNo: "",
  //     PanNo: "",
  //     AadharNo: "",
  //     BalanceAmount: "0",
  //     AdvanceAmount: "0",
  //     Discount: "0",
  //     CreditPeriod: "0",
  //     FineGold: "0",
  //     FineSilver: "0",
  //     VendorId: 0,
  //     AddToVendor: false,
  //     oldEntry: false,
  //   });
  // };

  const handleList = () => {
    // Custom logic for the List button
    console.log("List button clicked");
    setActive("List");
  };
  const handleSearchSubmit = () => {
    // You can handle the search logic here
    console.log("Searching for:", searchTerm);
  };

  const columns = [
    { key: "serialNumber", label: "S.No", type: "read", priority: 2 },
    { key: "FirmName", label: "Company Name", type: "checkbox", priority: 1 },

    { key: "VendorName", label: "Vendor Name", type: "read", priority: 3 },
    { key: "ContactNo", label: "Mobile", type: "read", priority: 4 },
    { key: "Email", label: "Email", type: "read", priority: 5 },
    { key: "BalanceAmt", label: "BalanceAmount", type: "read", priority: 6 },

    { key: "AdvanceAmt", label: "Advance Amount", type: "read", priority: 7 },
    { key: "GSTNo", label: "GST No", type: "read", priority: 8 },
    { key: "CustomerSlab", label: "Customer Slab", type: "read", priority: 9 },
    {
      key: "RateOfInterest",
      label: "Rate of Interest",
      type: "read",
      priority: 10,
    },
    {
      key: "CreditPeriodId",
      label: "Credit period",
      type: "read",
      priority: 11,
    },
  ];

  const handlenew = () => {
    setActive("AddNew");
  };

  return (
    <div>
      <AdminHeading />
      <div className="adminMainBodyBox">
        {showError ? (
          <AlertMessage message={messageToShow} type={messageType} />
        ) : null}
        <AdminBreadCrump
          title={"Add Vendor"}
          companyName={"Loyalstring"}
          module={"Product Masters"}
          page={"Vendor"}
        />
        <div style={{ padding: "16px" }}>
          {active == "List" ? (
            <>
              <div className={style["white-space"]}>
               

                <div className={style["icon-div"]}>
                  <div className={style["search-container"]}>
                    <input
                      type="text"
                      value={searchInput}
                      onChange={handleSearchChange}
                      placeholder="Search..."
                      className={style["serach-input"]}
                    />
                    <button
                      style={{ margin: 0 }}
                      className={style["search-btn"]}
                      onClick={handleSearchSubmit}
                    >
                      <Icon style={{ fontSize: "20px" }} icon="mdi:magnify" />
                    </button>
                  </div>
                  
                  <Icon
                  
                    style={{
                      fontSize: "28px ",
                      color: "#0077d4",
                      cursor: "pointer",
                    }}
                    icon="bx:export"
                  />
                  
                 
                  <button
                    // style={{ width: "30%" }}
                    className={style["custom-btn"]}
                  >
                    <Icon
                      style={{ fontSize: "24px " }}
                      icon="ic:outline-print"
                    />
                    Print
                  </button>
                  <button onClick={handlenew} style={{ margin: 0 }} className={style["custom-btn"]}>
                  New
                  <Icon icon="mdi:plus" width="24" height="24" />
                </button>
                </div>
              </div>

              
              <Customertable
                columns={columns}
                allCategories={allCategories}
                handleEditData={handleEditData}
                title={"All Vendors"}
                searchInput={searchInput}
                setSearchInput={setSearchInput}
              />
            </>
          ) : (
            <div className={style.adminAddCategoryMainBox}>
              <div className={style.adminAddCategoryInnerBox}>
                <div className={style.adminCategoryAddCategoryMainBox}>
                  <form onSubmit={addNewCategory}>
                    <div
                      style={{
                        gridTemplateColumns: "repeat(4,1fr)",
                        columnGap: "40px",
                      }}
                      // className="adminCategoryAddCategoryInnerBox"
                    >
                      <h2
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                        id="adminInvoiceAddedCustomerEdit"
                        // className="adminInvoiceAddTitles"
                        className={style.adminCategoryHeading}
                      >
                        Vendor Details
                      </h2>
                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>
                            Company Name<sup>*</sup>
                          </label>
                          <input
                            name="FirmName"
                            value={newCategory.FirmName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style.AddCustomerInput}
                            ref={inputRef1}
                            onKeyDown={(e) => handleKeyPress(e, inputRef2)}
                            style={{ border: "1px solid #ccc" }}
                          />

                          <label>
                            Vendor Name<sup>*</sup>
                          </label>
                          <input
                            name="VendorName"
                            value={newCategory.VendorName}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef2}
                            onKeyDown={(e) => handleKeyPress(e, inputRef3)}
                          />

                          <label>
                            Contact No.<sup>*</sup>
                          </label>
                          <input
                            name="ContactNo"
                            value={newCategory.ContactNo}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef3}
                            onKeyDown={(e) => handleKeyPress(e, inputRef4)}
                          />

                          <label>Email</label>
                          <input
                            name="Email"
                            value={newCategory.Email}
                            onChange={handleNewCategoryChange}
                            type="email"
                            // required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef4}
                            onKeyDown={(e) => handleKeyPress(e, inputRef5)}
                          />

                          <label>Aadhar Number</label>
                          <input
                            name="AadharNo"
                            value={newCategory.AadharNo}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef5}
                            onKeyDown={(e) => handleKeyPress(e, inputRef6)}
                          />
                          <label>Pan Number</label>
                          <input
                            name="PanNo"
                            value={newCategory.PanNo}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef6}
                            onKeyDown={(e) => handleKeyPress(e, inputRef7)}
                          />
                          <label>GST Number</label>
                          <input
                            name="GstNo"
                            value={newCategory.GstNo}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef7}
                            onKeyDown={(e) => handleKeyPress(e, inputRef8)}
                          />
                        </div>
                      </Box>
                      <h2
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                        id="adminInvoiceAddedCustomerEdit"
                        // className="adminInvoiceAddTitles"
                        className={style.adminCategoryHeading}
                      >
                        Additional Details
                      </h2>

                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>
                            Vendor Type<sup>*</sup>
                          </label>
                          <select
                            name="VendorType"
                            value={newCategory.VendorType}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef8}
                            onKeyDown={(e) => handleKeyPress(e, inputRef9)}
                          >
                            <option value={""}>Select an option</option>
                            <option value={"Party"}>Party</option>
                            <option value={"Karigar"}>Karigar</option>
                          </select>

                          <label>Customer Slab</label>
                          <select
                            // required="required"
                            type="text"
                            name="CustomerSlabId"
                            value={newCategory.CustomerSlabId}
                            onChange={handleNewCategoryChange}
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef9}
                            onKeyDown={(e) => handleKeyPress(e, inputRef10)}
                          >
                            <option value="">Select Customer Slab</option>
                            {customerSlabList.map((slab, index) => (
                              <option key={index} value={slab.Id}>
                                {slab.CustomerSlabName}
                              </option>
                            ))}
                          </select>
                          <label>Customer Rate Of Interest</label>
                          <select
                            // required="required"
                            type="text"
                            name="RateOfInterestId"
                            value={newCategory.RateOfInterestId}
                            onChange={handleNewCategoryChange}
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef10}
                            onKeyDown={(e) => handleKeyPress(e, inputRef11)}
                          >
                            <option value="">
                              Select Customer Rate Of Interest
                            </option>
                            {customerRateOfInterestList.map((slab, index) => (
                              <option key={index} value={slab.Id}>
                                {slab.RateOfInterest}
                              </option>
                            ))}
                          </select>
                          <label>Customer Credit Period</label>
                          <select
                            // required="required"
                            type="text"
                            name="CreditPeriodId"
                            value={newCategory.CreditPeriodId}
                            onChange={handleNewCategoryChange}
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef11}
                            onKeyDown={(e) => handleKeyPress(e, inputRef12)}
                          >
                            <option value="">
                              Select Customer Credit Period
                            </option>
                            {customerCreditPeriodList.map((credit, index) => (
                              <option key={index} value={credit.Id}>
                                {credit.CreditPeriod}
                              </option>
                            ))}
                          </select>
                          <label>Balance Amt.</label>
                          <input
                            name="BalanceAmt"
                            value={newCategory.BalanceAmt}
                            onChange={handleNewCategoryChange}
                            type="text"
                            // required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef12}
                            onKeyDown={(e) => handleKeyPress(e, inputRef13)}
                          />
                          <label>Advance Amt.</label>
                          <input
                            name="AdvanceAmt"
                            value={newCategory.AdvanceAmt}
                            onChange={handleNewCategoryChange}
                            type="text"
                            // required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef13}
                            onKeyDown={(e) => handleKeyPress(e, inputRef14)}
                          />
                          <label>Fine Gold</label>
                          <input
                            name="FineGold"
                            value={newCategory.FineGold}
                            onChange={handleNewCategoryChange}
                            type="text"
                            // required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef14}
                            onKeyDown={(e) => handleKeyPress(e, inputRef15)}
                          />
                          <label>Fine Silver</label>
                          <input
                            name="FineSilver"
                            value={newCategory.FineSilver}
                            onChange={handleNewCategoryChange}
                            type="text"
                            // required="required"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef15}
                            onKeyDown={(e) => handleKeyPress(e, inputRef16)}
                          />
                          <label>Add To Customer</label>
                          <select
                            name="AddToCustomer"
                            value={newCategory.AddToCustomer}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef16}
                            onKeyDown={(e) => handleKeyPress(e, inputRef17)}
                          >
                            <option value={false}>NO</option>
                            <option value={true}>YES</option>
                          </select>
                        </div>
                      </Box>

                      <h2
                        style={{ marginTop: "20px", marginBottom: "20px" }}
                        id="adminInvoiceAddedCustomerEdit"
                        // className="adminInvoiceAddTitles"
                        className={style.adminCategoryHeading}
                      >
                        Address Details
                      </h2>

                      <Box sx={{ width: "95%", margin: "0 auto" }}>
                        <div
                          style={{
                            gridTemplateColumns: "repeat(4,1fr)",
                            columnGap: "40px",
                            margin: "15px 0px",
                          }}
                          className="adminCategoryAddCategoryInnerBox"
                        >
                          <label>Street</label>
                          <input
                            name="CurrAddStreet"
                            value={newCategory.CurrAddStreet}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef17}
                            onKeyDown={(e) => handleKeyPress(e, inputRef18)}
                          />
                          <label>Area</label>
                          <input
                            name="CurrAddArea"
                            value={newCategory.Area}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef18}
                            onKeyDown={(e) => handleKeyPress(e, inputRef19)}
                          />
                          <label>Town</label>
                          <input
                            name="CurrAddTown"
                            value={newCategory.CurrAddTown}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef19}
                            onKeyDown={(e) => handleKeyPress(e, inputRef20)}
                          />
                          <label>
                            Country <sup>*</sup>
                          </label>
                          <select
                            name="CurrAddCountry"
                            value={newCategory.CurrAddCountry}
                            onChange={handleNewCategoryChange}
                            required="required"
                            className={style.AddCustomerSelect}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef20}
                            onKeyDown={(e) => handleKeyPress(e, inputRef21)}
                          >
                            {allCountriesList.map((x, y) => (
                              <option key={y} value={x}>
                                {x}
                              </option>
                            ))}
                          </select>
                          <label>
                            State <sup> *</sup>
                          </label>

                          <input
                            name="CurrAddState"
                            value={newCategory.CurrAddState}
                            onChange={handleNewCategoryChange}
                            type="text"
                            required="required"
                            list="CurrAddState"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef21}
                            onKeyDown={(e) => handleKeyPress(e, inputRef22)}
                          />
                          <datalist id="CurrAddState">
                            {countryStates.map((x, index) => (
                              <option key={index} value={x}>
                                {x}
                              </option>
                            ))}
                          </datalist>
                          <label>Pincode</label>
                          <input
                            name="CurrAddPincode"
                            value={newCategory.CurrAddPincode}
                            onChange={handleNewCategoryChange}
                            type="text"
                            className={style.AddCustomerInput}
                            style={{ border: "1px solid #ccc" }}
                            ref={inputRef22}
                            onKeyDown={(e) => handleKeyPress(e, null)}
                          />
                        </div>
                      </Box>
                    </div>

                    {!loading ? (
                      <div className={style["btn-container"]}>
                        <button className={style.buttons} type="submit">
                          <Icon
                            icon="ic:baseline-check"
                            width="24"
                            height="24"
                          />
                          Submit
                        </button>
                        <button
                          className={style.buttons}
                          style={{
                            backgroundColor: "#fff",
                            color: "#0077d4",
                            border: "1px solid #0077d4",
                          }}
                          type="button"
                          onClick={handleResetField}
                        >
                          <Icon
                            style={{ color: "#0077d4" }}
                            icon="ix:reset"
                            width="24"
                            height="24"
                          />
                          Reset
                        </button>
                        <button
                          className={style.buttons}
                          type="button"
                          onClick={handleList}
                        >
                          <Icon
                            icon="fluent:list-rtl-16-filled"
                            width="24"
                            height="24"
                          />
                          List
                        </button>
                      </div>
                    ) : null}
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
